import React from 'react';

/**
 * "Today" / "Yesterday" / "Tuesday" / "12 Mar" between the days of a stream.
 *
 * The support pane grew this markup first, with its own `dayLabel` beside it. It
 * is a component now because the three chat streams need the same thing, and a
 * fourth copy of "which day is this bubble on" is three too many — the label
 * itself comes from `dayDividerFor` in config/util.
 *
 * Renders nothing without a label, so a caller can pass the result of
 * `dayDividerFor` straight through without guarding it.
 *
 * `aria-hidden`, because every bubble already carries its own timestamp; a screen
 * reader announcing "Today" between messages adds nothing it does not have. The
 * label is a real element rather than a `::before` so it stays translatable.
 *
 * Sticky positioning lives in `.stream-day` — see index.css for why it has to be
 * a direct child of the scroll container.
 */
const DayDivider = ({ label }) =>
  label ? (
    <div className="stream-day" aria-hidden="true">
      <span>{label}</span>
    </div>
  ) : null;

export default DayDivider;
